import HyundaiPortal from "@/pages/HyundaiPortal";
import { GM } from "@/lib/portalBrands";

export default function GMPortal() {
  return <HyundaiPortal cfg={GM} />;
}
